(() => {
  const root = document.querySelector('[data-cls]');
  if (!root) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobileHome = matchMedia('(max-width: 760px)');
  const menu = root.querySelector('[data-cls-menu]');
  const nav = root.querySelector('#cls-nav');
  menu?.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    menu.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
  });
  nav?.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      nav.classList.remove('is-open');
      menu?.setAttribute('aria-expanded', 'false');
    }
  });

  function dismissMenu(restoreFocus = false) {
    if (!nav?.classList.contains('is-open')) return;
    const focusInside = nav.contains(document.activeElement);
    nav.classList.remove('is-open');
    menu?.setAttribute('aria-expanded', 'false');
    menu?.setAttribute('aria-label', 'Abrir menú');
    if (restoreFocus || focusInside) menu?.focus({preventScroll:true});
  }
  document.addEventListener('pointerdown', event => {if (!nav?.contains(event.target) && !menu?.contains(event.target)) dismissMenu();});
  document.addEventListener('keydown', event => {if (event.key === 'Escape' && nav?.classList.contains('is-open')) {dismissMenu(true); event.preventDefault();}});
  const slides = [...root.querySelectorAll('[data-cls-star-slide]')];
  const star = root.querySelector('[data-cls-star]');
  const count = root.querySelector('[data-cls-star-count]');
  let active = slides.length ? Math.floor(Math.random() * slides.length) : 0;
  let starTimer;
  let starVisible = true;
  let starPaused = false;
  function showStar(index) {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const selected = i === active;
      slide.classList.toggle('is-active', selected);
      slide.setAttribute('aria-hidden', String(!selected));
      slide.querySelectorAll('a').forEach((link) => link.tabIndex = selected ? 0 : -1);
    });
    if (count) count.textContent = `${active + 1} / ${slides.length}`;
  }
  function updateStarTimer() {
    clearInterval(starTimer);
    if (!mobileHome.matches && !reduced.matches && !document.hidden && starVisible && !starPaused && slides.length > 1) {
      starTimer = setInterval(() => showStar(active + 1), 8500);
    }
  }
  showStar(active);
  root.querySelector('[data-cls-star-prev]')?.addEventListener('click', () => { showStar(active - 1); updateStarTimer(); });
  root.querySelector('[data-cls-star-next]')?.addEventListener('click', () => { showStar(active + 1); updateStarTimer(); });
  star?.addEventListener('mouseenter', () => { starPaused = true; updateStarTimer(); });
  star?.addEventListener('mouseleave', () => { starPaused = false; updateStarTimer(); });
  star?.addEventListener('focusin', () => { starPaused = true; updateStarTimer(); });
  star?.addEventListener('focusout', (event) => { if (!star.contains(event.relatedTarget)) { starPaused = false; updateStarTimer(); } });
  if ('IntersectionObserver' in window && star) {
    new IntersectionObserver(([entry]) => { starVisible = entry.isIntersecting; updateStarTimer(); }, { threshold: .15 }).observe(star);
  }
  document.addEventListener('visibilitychange', updateStarTimer);
  reduced.addEventListener?.('change', updateStarTimer);
  mobileHome.addEventListener?.('change', updateStarTimer);
  updateStarTimer();

  const reveal = [...root.querySelectorAll('.cls-reveal')];
  if ('IntersectionObserver' in window && !reduced.matches) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -40px 0px', threshold: .08 });
    reveal.forEach((element) => observer.observe(element));
  } else reveal.forEach((element) => element.classList.add('is-visible'));

  const rail = root.querySelector('[data-cls-products-rail]');
  const next = () => rail?.scrollBy({ left: rail.querySelector('.cls-card')?.getBoundingClientRect().width + 13 || 200, behavior: reduced.matches ? 'instant' : 'smooth' });
  const prev = () => rail?.scrollBy({ left: -(rail.querySelector('.cls-card')?.getBoundingClientRect().width + 13 || 200), behavior: reduced.matches ? 'instant' : 'smooth' });
  root.querySelector('[data-cls-products-next]')?.addEventListener('click', next);
  root.querySelector('[data-cls-products-prev]')?.addEventListener('click', prev);
  let railTimer;
  let railVisible = false;
  let railPaused = false;
  function updateRailTimer() {
    clearInterval(railTimer);
    if (!rail || reduced.matches || document.hidden || !railVisible || railPaused) return;
    railTimer = setInterval(() => {
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 12;
      rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + (rail.querySelector('.cls-card')?.getBoundingClientRect().width || 185) + 13, behavior: 'smooth' });
    }, 6200);
  }
  if (rail && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => { railVisible = entry.isIntersecting; updateRailTimer(); }, { threshold: .3 }).observe(rail);
  rail?.addEventListener('mouseenter', () => { railPaused = true; updateRailTimer(); });
  rail?.addEventListener('mouseleave', () => { railPaused = false; updateRailTimer(); });
  rail?.addEventListener('focusin', () => { railPaused = true; updateRailTimer(); });
  rail?.addEventListener('focusout', (event) => { if (!rail.contains(event.relatedTarget)) { railPaused = false; updateRailTimer(); } });
  document.addEventListener('visibilitychange', updateRailTimer);
  reduced.addEventListener?.('change', updateRailTimer);

  const form = root.querySelector('[data-cls-search-form]');
  const input = root.querySelector('[data-cls-search-input]');
  const suggestions = root.querySelector('[data-cls-suggest]');
  const status = root.querySelector('[data-cls-search-status]');
  
  let searchTimer;
  let searchController;
  let requestNumber = 0;
  const money = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(amount) || 0);
  const setStatus = (message) => { status.textContent = message; };
  function closeSuggestions() { suggestions.hidden = true; suggestions.replaceChildren(); }
  const searchPath = new URL(form.action, location.href).pathname.replace(/search\/?$/, 'search/suggest.json');
  async function searchProducts(query) {
    const current = ++requestNumber;
    searchController?.abort();
    if (query.trim().length < 2) { closeSuggestions(); return; }
    searchController = new AbortController();
    const url = new URL(searchPath, location.origin);
    url.searchParams.set('q', query.trim());
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[options][fields]', 'title,vendor,product_type,variants.title');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    try {
      const searchIntent = window.ClikeaSearch.intent(query);
      const categorySearch = searchIntent.renal || ['Juguetes','Accesorios'].includes(searchIntent.category);
      const response = categorySearch ? {ok:true} : await fetch(url, { signal: searchController.signal });
      if (!response.ok) throw new Error('search unavailable');
      const data = categorySearch ? {resources:{results:{products:await window.ClikeaSearch.suggestions(query, searchController.signal)}}} : await response.json();
      if (current !== requestNumber) return;
      const products = window.ClikeaSearch.rank(data.resources?.results?.products || [], query).slice(0,5);
      suggestions.replaceChildren();
      products.forEach((product) => {
        const link = document.createElement('a');
        link.href = product.url;
        if (product.featured_image?.url) {
          const img = document.createElement('img');
          img.src = product.featured_image.url;
          img.alt = '';
          img.loading = 'lazy';
          link.append(img);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = product.title;
        const price = document.createElement('small');
        price.textContent = (product.available === false ? 'Agotado · ' : '') + money(product.price);
        copy.append(title, price); link.append(copy); suggestions.append(link);
      });
      suggestions.hidden = products.length === 0;
      if (!products.length) setStatus('No encontramos coincidencias. Prueba otra palabra o abre la búsqueda completa.');
      else if (status.textContent.startsWith('No encontramos')) setStatus('');
    } catch (error) { if (error.name !== 'AbortError' && current === requestNumber) { closeSuggestions(); setStatus('No se pudieron cargar sugerencias. Puedes buscar con Enter.'); } }
  }
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = input.value;
    requestNumber++; searchController?.abort(); closeSuggestions(); setStatus('');
    if (query.trim().length < 2) { requestNumber++; searchController?.abort(); closeSuggestions(); return; }
    searchTimer = setTimeout(() => searchProducts(query), 230);
  });
  input?.addEventListener('focus', () => { if (input.value.trim().length > 1) searchProducts(input.value); });
  document.addEventListener('click', (event) => { if (!form.contains(event.target) && !suggestions.contains(event.target)) closeSuggestions(); });
  input?.addEventListener('keydown', (event) => { if (event.key === 'Escape') {clearTimeout(searchTimer);requestNumber++;searchController?.abort();closeSuggestions();} });
  document.addEventListener('visibilitychange', () => {if(document.hidden){clearTimeout(searchTimer);requestNumber++;searchController?.abort();closeSuggestions();}});
  form?.addEventListener('submit', () => {clearTimeout(searchTimer);requestNumber++;searchController?.abort();closeSuggestions();});

})();
